import { post, postWithMultipartFormData } from '../utils/http';
import { get } from './cache';
import constants, { DEFAULT_CHECKOUT_CONFIG, DEFAULT_GRADIENT_COLOR } from '../utils/constants';

class API {
  onSaveSetting(
    selectedObj,
    CHECKOUT = {},
    isPaytmBrandingDisplay,
    isAutoLoginSupported,
    isCustomPaymodeSelected,
    reOrderedPaymodes,
    isGradientEffectEnable,
    isParentThemeOverwriteEnabled,
    onInvertImgLogo
  ) {
    let paytmLogo = onInvertImgLogo ? 'WHITE-LOGO' : 'BLUE-LOGO';
    const mid = get(constants.MID);
    const url = `${get(constants.SAVEURL)}/${mid}`;
    const isLightTheme = !!(!selectedObj || selectedObj.mobile.NAME == 'LIGHT');
    isLightTheme ? (paytmLogo = 'BLUE-LOGO') : selectedObj.mobile.NAME == 'DARK' ? (paytmLogo = 'WHITE-LOGO') : '';
    let checkoutObj = {};
    Object.assign(checkoutObj, DEFAULT_CHECKOUT_CONFIG, CHECKOUT);
    selectedObj.gradient =
      selectedObj.mobile.NAME === 'CUSTOM' && isGradientEffectEnable ? selectedObj.gradient : DEFAULT_GRADIENT_COLOR;

    if (!selectedObj.merchant) {
      selectedObj.merchant = {};
    }
    if (!selectedObj.payMode) {
      selectedObj.payMode = {};
    }

    /**
      No need to save the color value for Light theme for checkout js, because Light theme is 
      different for checkout and redirection flow
    */
    checkoutObj.style.bodyBackgroundColor = isLightTheme ? '' : selectedObj.mobile.BODYBG;
    checkoutObj.style.bodyColor = isLightTheme ? '' : selectedObj.mobile.BODYTEXT;
    checkoutObj.style.themeBackgroundColor = isLightTheme ? '' : selectedObj.mobile.PAYBUTTONBG;
    checkoutObj.style.themeColor = isLightTheme ? '' : selectedObj.mobile.PAYBUTTONTEXT;
    checkoutObj.style.headerBackgroundColor = isLightTheme ? '' : selectedObj.mobile.HEADERPANEL;
    checkoutObj.style.headerColor = isLightTheme ? '' : selectedObj.mobile.HEADERTEXT;
    checkoutObj.style.borderColor = isLightTheme ? '' : selectedObj.mobile.BORDER;
    checkoutObj.style.gradient = selectedObj.gradient;
    checkoutObj.style.label = selectedObj.mobile.LABEL;
    checkoutObj.style.name = selectedObj.mobile.NAME;

    checkoutObj.merchant.hidePaytmBranding = !isPaytmBrandingDisplay;
    checkoutObj.payMode.order = reOrderedPaymodes;
    selectedObj.merchant.hidePaytmBranding = !isPaytmBrandingDisplay;
    selectedObj.payMode.order = reOrderedPaymodes;

    if (selectedObj && selectedObj.mobile && selectedObj.web) {
      selectedObj.mobile.BOTTOMBG = selectedObj.mobile.HEADERPANEL;
      selectedObj.web.BOTTOMBG = selectedObj.web.HEADERPANEL;
    }

    if(selectedObj.merchant.merchantLogoFile) {delete selectedObj.merchant.merchantLogoFile}
    if(selectedObj.merchant.merchantLogoUrl) {delete selectedObj.merchant.merchantLogoUrl}

    const dataObj = {
      themePreferenceInfos: {
        REDIRECTION: selectedObj,
        CHECKOUT: checkoutObj,
        isCustomPaymodeSelected,
        isGradientEffectEnable,
        isParentThemeOverwriteEnabled,
        paytmLogo
      },
      merchantPreferenceInfos: {
        isPaytmBrandingDisplay,
        isAutoLoginSupported
      }
    };
    return post(url, dataObj);
  }

  onSaveUpdate(payload) {
    const url = `${constants.saveUpdateUrl}`;
    return post(url, payload, '', false);
  }

  onDeleteField(payload) {
    const url = `${constants.deleteField}`;
    return post(url, payload, '', false);
  }

  templateFields(payload) {
    const url = `${constants.fetchTemplateFieldsForPreview}/${payload.templateId}`;
    return post(url, payload);
  }

  updateCheckoutPreference(payload) {
    const mid = get(constants.MID);
    const url = `${constants.updatePreference}/${mid}`;
    return post(url, { preference: payload });
  }

  onButtonSaveUpdate(payload) {
    const url = `${constants['saveUpdateButtonApi']}`;
    return post(url, payload);
  }
  
  fetchLinks(payload) {
    const url = constants.FETCH_LINKS;
    return post(url, payload);
  }

  updateLinks(payload) {
    const url = constants.UPDATE_LINKS;
    return post(url, payload, '', false);
  }

  onSaveMerchantLogo(logoFile){
    const mid = get(constants.MID);
    const url = `${get(constants.SAVEURL)}/merchantlogo/${mid}`;
    return postWithMultipartFormData(url, logoFile)
  };
}

export default new API();



// WEBPACK FOOTER //
// ./common/api.js